// A $( document ).ready() block.
$( document ).ready(function() {
  if($('.shopify-section--rich-text button').length){
    $( ".richtext" ).each(function( index ) {
      if(index > 0){
        $(this).hide();
      }
    });
    if($('.shopify-section--rich-text button').html().indexOf('READ MORE') != -1){
        if($( ".richtext" ).length < 2){
          $('.shopify-section--rich-text button').hide();
        }
      }
  }
  if($('.list-dimensions').length){
    $( ".list-dimensions" ).each(function( index ) {
      if($(this).html() =='0 x 0 x 0 mm'){
        $(this).hide();
      }
      if($(this).html() ==' x  x  mm'){
        $(this).hide();
      }
    });
  }
  $('.shopify-section--rich-text button').click(function(){
      if($(this).html().indexOf('READ MORE') != -1){
        $( ".richtext" ).show();
        $(this).html('<div>READ LESS</div>');
      }else{
        $( ".richtext" ).each(function( index ) {
          if(index > 0){
            $(this).hide();
          }
        });
        $(this).html('<div>READ MORE</div>');
      }
    });
    $('#btn-read-more').click(function(){
      $(".description3").toggle();
      if($(".description3").is(":visible")){
        $('#btn-read-more').html('READ LESS');
      }else{
        $('#btn-read-more').html('READ MORE');
      }
    });
  
  let qtyMin = parseInt($('#qty-min').val());
  let qtyMax = parseInt($('#qty-max').val());
  let qtyPack = parseInt($('#qty-pack').val());
  if($('.qty-min-variant').length){
      let variantId = $('#variant-id').val();
       qtyMin = parseInt($('#qty-min-'+variantId).val());
      qtyPack = parseInt($('#qty-pack-'+variantId).val());
    $('.shipping-note').hide();
          $('#shipping-note-'+variantId).show();
  }
  if(Number.isNaN(qtyMin) || qtyMin < 1){
    $('.qty-minimum').hide();
    $('.qty-note').hide();
    
  } 
  if(Number.isNaN(qtyMin) || qtyMin < 1) qtyMin = 1;
  $('.quantity-selector input').val(qtyMin);
  if(Number.isNaN(qtyPack) || qtyPack < 1) $('.qty-order-lots').hide();
  if(Number.isNaN(qtyMax) || qtyMax < 1){
    $('.qty-maxnimum').hide();
  } else{
    $('.qty-maxnimum').show();
  }
  
  $('.quantity-selector__button[aria-label="Increase quantity"]').click(function(){
      setTimeout(function(){
        let qty2 = parseInt($('.quantity-selector input').val());
        let qtyPack2 = parseInt($('#qty-pack').val());
        let qtyMin2 = parseInt($('#qty-min').val());
        let qtyMax2 = parseInt($('#qty-max').val());
        
        if($('.qty-min-variant').length){
            let variantId2 = $('#variant-id').val();
           qtyMin2 = parseInt($('#qty-min-'+variantId2).val());
           qtyPack2 = parseInt($('#qty-pack-'+variantId2).val());
          if(Number.isNaN(qtyPack2) || qtyPack2 < 1) qtyPack2 = 1;
        }
        if(qty2 < qtyMin2){
          $('.quantity-selector input').val(qtyMin2);
          $('.quantity-selector input').attr('size',3);
        }else{
          let newQty = qty2+qtyPack2;
          $('.quantity-selector input').val(newQty);
          $('.quantity-selector input').attr('size',newQty.length);
        }
        if(qtyMax2 <= qty2 && qtyMax2 > 0){
          $('.quantity-selector input').val(qtyMax2);
          $('.quantity-selector input').attr('size',3);
        }
      }, 0);
      
    });
    $('.quantity-selector__button[aria-label="Decrease quantity"]').click(function(){
      setTimeout(function(){
        let qty3 = parseInt($('.quantity-selector input').val());
        let qtyPack3 = parseInt($('#qty-pack').val());
        let qtyMin3 = parseInt($('#qty-min').val());
        if($('.qty-min-variant').length){
            let variantId3 = $('#variant-id').val();
           qtyMin3 = parseInt($('#qty-min-'+variantId3).val());
           qtyPack3 = parseInt($('#qty-pack-'+variantId3).val());
          if(Number.isNaN(qtyPack3)  || qtyPack3 < 1) qtyPack3 = 1;
        }
         if(Number.isNaN(qtyMin3)) qtyMin3 = 1;
        if(qty3 < qtyMin3){
          $('.quantity-selector input').val(qtyMin3);
          $('.quantity-selector input').attr('size',3);
        }else{
          let newQty3 = qty3-qtyPack3;
          if(newQty3 < qtyMin3) newQty3 = qtyMin3;
          $('.quantity-selector input').val(newQty3);
          $('.quantity-selector input').attr('size',newQty3.length);
        }
      }, 0);
      
    });
    $(".quantity-selector input").change(function(){
      let qty4 = parseInt($(this).val());
      let qtyMin4 = parseInt($('#qty-min').val());
      let qtyPack4 = parseInt($('#qty-pack').val());
      let qtyMax4 = parseInt($('#qty-max').val());
      if(qty4 < qtyMin4){
          $(this).val(qtyMin4);
        $('.quantity-selector input').attr('size',5);
        }
      if($('.qty-min-variant').length){
            let variantId4 = $('#variant-id').val();
           qtyMin4 = parseInt($('#qty-min-'+variantId4).val());
           qtyPack4 = parseInt($('#qty-pack-'+variantId4).val());
          if(Number.isNaN(qtyPack4)  || qtyPack4 < 1) qtyPack4 = 1;
        }
      if(qty4 < qtyMin4){
          $(this).val(qtyMin4);
        $('.quantity-selector input').attr('size',5);
        }
      if(Number.isNaN(qtyMin4)) qtyMin4 = 1;
      let qty_divisible = parseInt(qty4 % qtyPack4);
      if(qty_divisible > 0){
        let newqty4 = qty4 + qtyPack4 - qty_divisible;
        
        $(this).val(newqty4);
        $('.quantity-selector input').attr('size',newqty4.length);
      }
      if(qtyMax4 <= qty4 && qtyMax4 > 0){
          $('.quantity-selector input').val(qtyMax4);
          $('.quantity-selector input').attr('size',3);
        }
    });

    

    if($(window).width() < 1024){
      $( ".footer__aside-top" ).insertAfter( ".footer__block--newsletter .v-stack" );
    }
  
    
});

$(window).on('load', function() {
  $('body').addClass('loaded');
  setTimeout(function(){
    if($('.hulkapps-table tbody').is(':empty')){
      $('.hulkapps-table').hide();
      $('.product-info .product-info__price').show();
    }
  }, 500);
  
  if($('.list-dimensions').length){
    $( ".list-dimensions" ).each(function( index ) {
      if($(this).html() =='0 x 0 x 0 mm'){
        $(this).hide();
      }
      if($(this).html() ==' x  x  mm' || $(this).html() =='x  x  mm'){
        $(this).hide();
      }
    });
  }

  $(".select-option-fake").change(function(e){
    var selected = $(this).val();
    $( "button.single-option-selector" ).each(function( index ) {
      if(selected == $(this).val()){
        $( this ).trigger( "click" );
      }
    });
  });
  
  $(".cart-drawer__inner").on("change",".quantity-input-fake", function(){
      let qtyMinCart = parseInt($(this).attr('qty-min'));
      let qtyPackCart = parseInt($(this).attr('qty-pack'));
      let qtyCart = parseInt($(this).val());
      if(qtyCart < qtyMinCart) qtyCart = qtyMinCart;
      if(Number.isNaN(qtyPackCart)  || qtyPackCart < 1) qtyPackCart = 1;
      if(Number.isNaN(qtyMinCart)) qtyMinCart = 1;
      let qtyDivisibleCart = parseInt(qtyCart % qtyPackCart);
      if(qtyDivisibleCart > 0){
        let newQtyCart = qtyCart + qtyPackCart - qtyDivisibleCart;
        $(this).val(newQtyCart);
        $(this).attr('size',newQtyCart.length);
        qtyCart = newQtyCart;
      }else{
        $(this).val(qtyCart);
        $(this).attr('size',qtyCart.length);
      }
  });
  $(".order-summary .quantity-input-fake").change(function(e){
      let qtyMax = parseInt($(this).attr('qty-max'));
      let qtyMinCart = parseInt($(this).attr('qty-min'));
      let qtyPackCart = parseInt($(this).attr('qty-pack'));
      let qtyCart = parseInt($(this).val());
      if(qtyCart < qtyMinCart) qtyCart = qtyMinCart;
      if(Number.isNaN(qtyPackCart)  || qtyPackCart < 1) qtyPackCart = 1;
      if(Number.isNaN(qtyMinCart)) qtyMinCart = 1;
      if(Number.isNaN(qtyMax)  || qtyMax < 1) qtyMax = 1111111110;
      if(qtyMax < qtyCart){
        $(this).val(qtyMax);
        return;
      }
      
      let qtyDivisibleCart = parseInt(qtyCart % qtyPackCart);
      if(qtyDivisibleCart > 0){
        let newQtyCart = qtyCart + qtyPackCart - qtyDivisibleCart;
        $(this).val(newQtyCart);
        $(this).attr('size',newQtyCart.length);
        qtyCart = newQtyCart;
      }else{
        $(this).val(qtyCart);
        $(this).attr('size',qtyCart.length);
      }
      let lineKey = $(this).attr('data-line-key');
      location.href = location.href + '/change?id='+lineKey+'quantity='+qtyCart;
      
    });
  setTimeout(function(){
    if($('.shopify-product-form .hulkapps-volumes').length){
      $('.shopify-product-form .hulkapps-volumes').detach().appendTo('.hulkapps-box-content');
      $('.hulkapps-volumes').show();
    }else{
      $('.hulkapps-box').hide();
    }
    $('.uploadkit.uploadkit-injected').insertAfter('.buy-buttons--multiple');
    if($('.uploadkit-uploader').css('display') == 'block'){
      $('.shopify-product-form').addClass('show-btn-upload');
    }else{
      $('.shopify-product-form').removeClass('show-btn-upload');
      
    }

    if($('#zakeke-product-button').length){
      $('#zakeke-product-button').insertBefore('.buy-buttons .button--secondary');
      $('#zakeke-product-button').addClass('button button--xl button--secondary');
    }else{
      //$('.hulkapps-box').hide();
    }
    if($('variant-option-value[for="option2"]').length){
      //$( '.print-note' ).insertAfter( 'variant-option-value[for="option2"]' );
    }
    if($('.product-info__buy-buttons .colorlab-atc-clone').length){
      $('.product-info__buy-buttons .colorlab-atc-clone').html('DESIGN ONLINE');
      $('.print-note').show();
      
    }
    
    if($('form.installment.caption-large').length){
      $('form.installment.caption-large').insertAfter('.uploadkit');
      $('#ProductSubmitButton-add-to-cart').prop('disabled', true);
      $('.shopify-payment-button__button').prop('disabled', true);
     $('#zakeke-product-button').prop('disabled', true);
    }
    $('variant-option-value').each(function( index ) {
      $('.swatch-box label[data-value="'+$(this).html()+'"]').addClass('checked');
    });
    if($('variant-option-value[for="option2"]').html() == 'Yes - Printed'){
      $('.print-note').show();
    }
    
    $('label.block-swatch ').click(function(){
      if($(this).html() == "No - Plain"){
        $('.product-info__buy-buttons .colorlab-atc-clone').hide();
      }else{
        $('.product-info__buy-buttons .colorlab-atc-clone').show();
      }
    });
    $('.swatch-box label, label.block-swatch ').click(function(){
      
      setTimeout(function(){
        $('.swatch-box label').removeClass('checked');
        $('variant-option-value').each(function( index ) {
          $('.swatch-box label[data-value="'+$(this).html()+'"]').addClass('checked');
        });
        if($('.product-info__buy-buttons .colorlab-atc-clone').length){
          $('.product-info__buy-buttons .colorlab-atc-clone').html('DESIGN ONLINE');
        }
        if($('.uploadkit-uploader').css('display') == 'block'){
          $('.shopify-product-form').addClass('show-btn-upload');
        }else{
          $('.shopify-product-form').removeClass('show-btn-upload');
        }
        var optChecked = $('variant-option-value[for="option2"]').html();
        if(optChecked == 'No - Plain'){
          $('.print-note').hide();
        }else{
          $('.print-note').show();
        }

        let qtyMin5 = parseInt($('#qty-min').val());
      let qtyPack5 = parseInt($('#qty-pack').val());
        let qtyMax5 = parseInt($('#qty-max').val());
      if($('.qty-min-variant').length){
            let variantId5 = $('#variant-id').val();
           qtyMin5 = parseInt($('#qty-min-'+variantId5).val());
           qtyPack5 = parseInt($('#qty-pack-'+variantId5).val());
          $('#qty-min').val(qtyMin5);
          $('#qty-pack').val(qtyPack5);
          $('.shipping-note').hide();
          $('#shipping-note-'+variantId5).show();
        }
        if(Number.isNaN(qtyMin5)) {qtyMin5 = 1;$('.qty-minimum').hide();}
      $('.quantity-selector input').val(qtyMin5);
          $('.quantity-selector input').attr('size',qtyMin5.length);
          if(Number.isNaN(qtyMin5) || qtyMin5 <= 1){
             $('.qty-minimum').hide();
          }else{
             $('.qty-minimum').show();
          }
          if(Number.isNaN(qtyPack5) || qtyPack5 < 1){
            $('.qty-order-lots').hide();
          } else{
            $('.qty-order-lots').show();
          }
          if(Number.isNaN(qtyMax5) || qtyMax5 < 1){
            $('.qty-maxnimum').hide();
          } else{
            $('.qty-maxnimum').show();
          }
        
      }, 600);
      
      
    });
  }, 1500);
  
  if($(window).width() <767){
    $('.footer__block--menu p, .footer__block--text p ').click(function(){
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $(this).parent().addClass('active');
      }
    });
  }
  
});

$( window ).on( "resize", function() {
  if($(window).width() < 1024){
    $( ".footer__aside-top" ).insertAfter( ".footer__block--newsletter .v-stack" );
  }
  // if($(window).width() <767){
  //   $('.footer__block--menu p, .footer__block--text p ').click(function(){
  //     if($(this).parent().hasClass('active')){
  //       $(this).parent().removeClass('active');
  //     }else{
  //       $(this).parent().addClass('active');
  //     }
      
  //   });
  // }
} );